import type { Command } from '../types';
import { headlessCommands } from './headless';
import { viewCommand } from './view';
import { curlCommand } from './curl';
import { codeCommand } from './code';
import { login } from './login';
import { survey } from './survey';
import { ask } from './ask';
import { confirm } from './confirm';

/**
 * Full built-in command set for the Vue terminal app: the headless core set
 * (ls, cd, cat, grep, …) plus the Vue/app-only commands (`view` renders Vue
 * components; curl/code/login/survey/ask/confirm are app features).
 */
export const builtInCommands: Command[] = [
  ...headlessCommands,
  viewCommand,
  curlCommand,
  codeCommand,
  login,
  survey,
  ask,
  confirm,
];

export function registerBuiltInCommands(executor: any): void {
  for (const command of builtInCommands) {
    executor.registerCommand(command);
  }
}

export { headlessCommands, registerHeadlessCommands } from './headless';
